import { Component } from "react";
import { connect } from "react-redux";
import { Card, CardHeader, CardBody, Col, Row, Button } from "reactstrap";
import { PacmanLoader } from "react-spinners";
import {
  fetchCoursesForAdmin,
  fetchOrphanCoursesForAdmin,
} from "../../actions/coursesActions";
import ProgramLicenseCourseComponent from "../../components/ProgramLicense/ProgramLicenseCourseComponent";
import AddCourseToProgramLicenseModal from "../../components/ProgramLicense/AddCourseToProgramLicenseModal";
import CourseAdminNav from "../../components/Navigation/CourseAdminNav";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import axios from "../../services/api/api";
import { API_BASE_URL } from "../../constants/api.constants";
import { toast } from "react-toastify";
import ModifyProgramLicenseModal from "../../components/Modal/ModifyProgramLicenseModal";
import SetCourseOrderInLicenseModal from "../../components/Modal/SetCourseOrderInLicenseModal";
import AddNewProgramModal from "../../components/ProgramLicense/AddNewProgramModal";
import { FormattedMessage } from "react-intl";

class ProgramLicenses extends Component {
  state = {
    toggled: null,
    modalIsOpen: false,
    selectedLicenseId: 0,
    selectedLicenseName: "",
    postingCourseToLicense: false,
    removingCourseFromLicense: [],
    sortModalIsOpen: false,
    newProgramModalIsOpen: false,
    editLicenseModalIsOpen: false,
    selectedLicenseImage: null,
  };

  componentDidMount() {
    this.props.dispatch(fetchCoursesForAdmin());
    this.props.dispatch(fetchOrphanCoursesForAdmin());
  }

  disconnect = (licenseName, courseId) => {
    this.setState({
      removingCourseFromLicense: [
        { licenseName: licenseName, courseId: courseId },
      ],
    });
    axios
      .delete(
        `${API_BASE_URL}/ProgramLicense/RemoveCoursesFromProgramLicense?licenseName=${licenseName}&courseId=${courseId}`
      )
      .then(() => {
        toast.success(
          "Kursen har plockats bort ifrån programlicensen",
          this.toastOptions
        );
        this.setState({
          removingCourseFromLicense:
            this.state.removingCourseFromLicense.filter(function (item) {
              return (
                item.licenseName !== licenseName && item.courseId !== courseId
              );
            }),
        });
        this.refresh();
      })
      .catch((err) => {
        toast.warn(
          err && err.response && err.response.data
            ? err.response.data
            : "Det gick inte att koppla ifrån kursen ifrån programlicensen",
          this.toastOptions
        );
        this.setState({
          removingCourseFromLicense:
            this.state.removingCourseFromLicense.filter(function (item) {
              return (
                item.licenseName !== licenseName && item.courseId !== courseId
              );
            }),
        });
      });
  };

  refresh = () => {
    this.props.dispatch(fetchCoursesForAdmin());
  };
  addCourses = (courses) => {
    this.setState({
      postingCourseToLicense: true,
    });
    axios
      .post(
        `${API_BASE_URL}/ProgramLicense/AddCoursesToProgramLicense?licenseName=${
          this.state.selectedLicenseName
        }&courseIds=${courses.map((x) => x.value).join("&courseIds=")}`
      )
      .then(() => {
        toast.success(
          "Kurserna har lagts till i programlicensen",
          this.toastOptions
        );
        this.setState({
          postingCourseToLicense: false,
        });
        this.refresh();
        this.toggleAddCourseModal(0, "");
      })
      .catch((err) => {
        toast.warn(
          err && err.response && err.response.data
            ? err.response.data
            : "Det gick inte att lägga till kurserna i programlicensen",
          this.toastOptions
        );
        this.setState({
          postingCourseToLicense: false,
        });
      });
  };

  toggleAddCourseModal = (licenseId, licenseName) => {
    this.setState({
      modalIsOpen: !this.state.modalIsOpen,
      selectedLicenseId: licenseId,
      selectedLicenseName: licenseName,
    });
  };

  toggleSortModal = () => {
    this.setState({ sortModalIsOpen: !this.state.sortModalIsOpen });
  };

  render() {
    if (this.props.courses.loading) {
      return (
        <div
          className="sweet-loading"
          style={{ position: "fixed", top: "50%", left: "50%" }}
        >
          <PacmanLoader color={"#20a8d8"} loading={true} />
        </div>
      );
    }

    let allCourses = [];
    this.props.courses.result.forEach((program) => {
      allCourses = [allCourses, ...program.courses];
    });

    let mappedLicense = [];

    if (this.props.courses.result.length > 0)
      mappedLicense = this.props.courses.result.map((license, i) => {
        return (
          <Col lg="4" key={i}>
            <Card>
              <CardHeader>
                <div className="d-flex align-items-center m-1">
                  <Col lg="8" className="me-3">
                    {license.program.licenseName}
                  </Col>
                  <Col lg="4">
                    <Button
                      outline
                      size="sm"
                      title="Lägg till kurser"
                      color="primary"
                      className="me-2"
                      onClick={() =>
                        this.setState({
                          modalIsOpen: !this.state.modalIsOpen,
                          selectedLicenseId: license.program.id,
                          selectedLicenseName: license.program.licenseName,
                        })
                      }
                    >
                      <FontAwesomeIcon icon="plus" />
                    </Button>
                    <Button
                      outline
                      size="sm"
                      title="Ändra sorteringsordning"
                      color="primary"
                      className="me-2"
                      onClick={() =>
                        this.setState({
                          sortModalIsOpen: !this.state.sortModalIsOpen,
                          selectedLicenseId: license.program.id,
                        })
                      }
                    >
                      <FontAwesomeIcon icon="edit" />
                    </Button>
                    <Button
                      outline
                      size="sm"
                      title="Redigera programlicens"
                      color="primary"
                      onClick={() =>
                        this.setState({
                          editLicenseModalIsOpen:
                            !this.state.editLicenseModalIsOpen,
                          selectedLicenseId: license.program.id,
                          selectedLicenseName: license.program.licenseName,
                          selectedLicenseImage: license.program.image,
                        })
                      }
                    >
                      <FontAwesomeIcon icon="image" />
                    </Button>
                  </Col>
                </div>
              </CardHeader>
              <CardBody>
                <ProgramLicenseCourseComponent
                  program={license.program}
                  courses={license.courses}
                  disconnect={this.disconnect}
                  removingCourseFromLicense={
                    this.state.removingCourseFromLicense
                  }
                />
              </CardBody>
            </Card>
          </Col>
        );
      });

    return (
      <div>
        <CourseAdminNav location="licenses" history={this.props.history} />
        <div className="animated fadeIn">
          <div className="container-fluid admin-container">
            <Row className="mb-2">
              <Col>
                <Button
                  outline
                  color="primary"
                  onClick={() => this.setState({ newProgramModalIsOpen: true })}
                  className="mb-2"
                >
                  <FormattedMessage id="AddNewProgram" />
                </Button>
              </Col>
            </Row>
            <Row>{mappedLicense}</Row>
            <ModifyProgramLicenseModal
              isOpen={this.state.editLicenseModalIsOpen}
              toggle={() =>
                this.setState({
                  editLicenseModalIsOpen: !this.state.editLicenseModalIsOpen,
                })
              }
              licenseId={this.state.selectedLicenseId}
              licenseName={this.state.selectedLicenseName}
              licenseImage={this.state.selectedLicenseImage}
            />
            <SetCourseOrderInLicenseModal
              isOpen={this.state.sortModalIsOpen}
              toggle={this.toggleSortModal}
              courses={
                this.state.selectedLicenseId
                  ? this.props.courses.result.find(
                      (item) => item.program.id === this.state.selectedLicenseId
                    ).courses
                  : []
              }
              licenseId={this.state.selectedLicenseId}
            />
            <AddCourseToProgramLicenseModal
              isOpen={this.state.modalIsOpen}
              licenseId={this.state.selectedLicenseId}
              licenseName={this.state.selectedLicenseName}
              toggle={this.toggleAddCourseModal}
              addCourses={this.addCourses}
              posting={this.state.postingCourseToLicense}
            />
            <AddNewProgramModal
              isOpen={this.state.newProgramModalIsOpen}
              toggle={() =>
                this.setState({
                  newProgramModalIsOpen: !this.state.newProgramModalIsOpen,
                })
              }
            />
          </div>
        </div>
      </div>
    );
  }
}

const mapStateToProps = (store) => {
  return {
    courses: store.coursesListReducer,
  };
};

export default connect(mapStateToProps)(ProgramLicenses);
